import * as z from 'zod'
import {buildEntrySchemaFor} from '../entry'
import {IntroItemSchema} from './introItem'
import {LinkSchema} from './link'
import {RichTextSchema} from '../richText'
import {safeOptional} from '../../safe-optional'

export const IntroStackedItemsSchema = buildEntrySchemaFor('introStackedItems', {
  fields: z.lazy(() =>
    z.object({
      headline: z.union([z.string(), RichTextSchema]),
      items: z.array(IntroItemSchema),
      link: safeOptional(LinkSchema),
    }),
  ),
})

export type IntroStackedItems = z.infer<typeof IntroStackedItemsSchema>
